import React from 'react'
import Section from '@/components/Section'
import Container from '@/components/Container'
import xp from '../../../images/xp.svg'
import TaxonomyHeader from '@/components/TaxonomyHeader'
import TaxonomyHeading from '@/components/TaxonomyHeading'
import TaxonomySubSection from '@/components/TaxonomySubSection'
import TaxonomySubSectionHeading from '@/components/TaxonomySubSectionHeading'
import TaxonomyBadges from '@/components/TaxonomyBadges'
import { transformTaxonomyList } from '@/utils/transformers'

export default function Experience({ data }) {
  const {
    special_considerations,
    onsite_activities,
    off_site_activities,
    off_site_amenities,
    onsite_amenities,
    personal_amenities
  } = data

  const personalAmenitiesBadges = transformTaxonomyList(personal_amenities)
  const specialConsiderationsBadges = transformTaxonomyList(
    special_considerations
  )
  const onsiteActivitiesBadges = transformTaxonomyList(onsite_activities)
  const offSiteActivitiesBadges = transformTaxonomyList(off_site_activities)
  const onsiteAmenitiesBadges = transformTaxonomyList(onsite_amenities)
  const offSiteAmenitiesBadges = transformTaxonomyList(off_site_amenities)

  return (
    <Section>
      <Container>
        <TaxonomyHeader>
          <img src={xp} />
          <TaxonomyHeading tag="h3">Experience</TaxonomyHeading>
        </TaxonomyHeader>

        {personalAmenitiesBadges.length > 0 && (
          <TaxonomySubSection>
            <TaxonomySubSectionHeading text="Personal Amenities" />
            <TaxonomyBadges itemsList={personalAmenitiesBadges} />
          </TaxonomySubSection>
        )}

        {onsiteAmenitiesBadges.length > 0 && (
          <TaxonomySubSection>
            <TaxonomySubSectionHeading text="Amenities" />
            <TaxonomyBadges itemsList={onsiteAmenitiesBadges} />
          </TaxonomySubSection>
        )}

        {specialConsiderationsBadges.length > 0 && (
          <TaxonomySubSection>
            <TaxonomySubSectionHeading text="Special Considerations" />
            <TaxonomyBadges itemsList={specialConsiderationsBadges} />
          </TaxonomySubSection>
        )}

        {onsiteActivitiesBadges.length > 0 && (
          <TaxonomySubSection>
            <TaxonomySubSectionHeading text="Activities" />
            <TaxonomyBadges itemsList={onsiteActivitiesBadges} />
          </TaxonomySubSection>
        )}

        {offSiteActivitiesBadges.length > 0 && (
          <TaxonomySubSection>
            <TaxonomySubSectionHeading text="Off-Site Activities" />
            <TaxonomyBadges itemsList={offSiteActivitiesBadges} />
          </TaxonomySubSection>
        )}

        {offSiteAmenitiesBadges.length > 0 && (
          <TaxonomySubSection>
            <TaxonomySubSectionHeading text="Off-Site Amenities" />
            <TaxonomyBadges itemsList={offSiteAmenitiesBadges} />
          </TaxonomySubSection>
        )}
      </Container>
    </Section>
  )
}
